import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./components/Login";
import WelcomePage from "./components/WelcomePage";
import UpdateLogin from "./components/UpdateLogin";
import Register from "./components/Register";
import UserDashboard from "./components/UserDashboard";
import UpdateUser from "./components/UpdateUser";
import EmployeeData from "./components/EmployeeData";
import LeaveRequest from "./components/LeaveRequest";
import LeaveRequestsTable from "./components/LeaveRequestsTable";
import LeaveRequestsAdmin from "./components/LeaveRequestsAdmin";
import LeaveSection from "./components/LeaveSection";
import LeaveRequestsRM from "./components/LeaveRequestsRM";
import MahaHolidayCalendar from "./components/MahaHolidayCalendar";
import GTMPageView from "./components/GTMPageView";
import UpdateUserPassword from "./components/UpdateUserPassword";
import "./styles/index.css";
import InfluencerTweets from "./components/InfluencerTweets";
import InfluencerProfile from "./components/InfluencerProfile";
import InfluencerLeaderboard from "./components/InfluencerLeaderboard";
import InfluencerAnalytics from "./components/InfluencerAnalytics";
import GeneralTweetSearch from "./components/GeneralTweetSearch";
import WorkspacePage from "./components/WorkspacePage";
import ChatPage from "./components/ChatPage";

const App = () => {
  return (
    <Router>
      <GTMPageView />
      <div className="app">
        <Routes>
          <Route path="/" element={<Login />} />
          
          {/* User Management Routes */}
          <Route
            path="/update-user/:userId"
            element={<ProtectedRoute element={<UpdateUser />} />}
          />
          <Route
            path="/update-user-password/:userId"
            element={<ProtectedRoute element={<UpdateUserPassword />} />}
          />
          <Route path="/update" element={<UpdateLogin />} />
          <Route
            path="/nWuRGm1GvLXyCmQ6TbxqfQ7YasvDlY8z87TxUHrX0HUhX0Pxa9"
            element={<ProtectedRoute element={<Register />} />}
          />
          
          {/* Main Pages */}
          <Route
            path="/welcome"
            element={<ProtectedRoute element={<WelcomePage />} />}
          />
          <Route
            path="/userdashboard"
            element={<ProtectedRoute element={<UserDashboard />} />}
          />
          <Route
            path="/emp-data"
            element={<ProtectedRoute element={<EmployeeData />} />}
          />
          
          {/* Leave Management Routes */}
          <Route
            path="/leave-form"
            element={<ProtectedRoute element={<LeaveRequest />} />}
          />
          <Route
            path="/leave-section"
            element={<ProtectedRoute element={<LeaveSection />} />}
          />
          <Route
            path="/leave-data"
            element={<ProtectedRoute element={<LeaveRequestsTable />} />}
          />
          <Route
            path="/leave-data-admin"
            element={<ProtectedRoute element={<LeaveRequestsAdmin />} />}
          />
          <Route
            path="/leave-data-rm"
            element={<ProtectedRoute element={<LeaveRequestsRM />} />}
          />
          <Route
            path="/maha-holiday-calendar"
            element={<ProtectedRoute element={<MahaHolidayCalendar />} />}
          />
          <Route
            path="/influencer-tweets"
            element={<ProtectedRoute element={<InfluencerTweets />} />}
          />
          <Route
            path="/influencer-profiles"
            element={<ProtectedRoute element={<InfluencerProfile />} />}
          />
          <Route
            path="/influencer-leaderboard"
            element={<ProtectedRoute element={<InfluencerLeaderboard />} />}
          />
          <Route
            path="/general-tweets"
            element={<ProtectedRoute element={<GeneralTweetSearch />} />}
          />
          <Route
            path="/influencer-analytics"
            element={<ProtectedRoute element={<InfluencerAnalytics />} />}
          />
          <Route
            path="/workspace"
            element={<ProtectedRoute element={<WorkspacePage />} />}
          />
          <Route
            path="/chats"
            element={<ProtectedRoute element={<ChatPage />} />}
          />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
